export default {
  routes: [
    {
      name: 'processes',
      path: '/directory/processes',
      component: () => import('./views/TheProcesses.vue'),
    },
  ],
}
